import axios from "axios";

const authConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const senaFunciones = {
  obtenerProgramas: async () => {
    try {
      const response = await axios.get("/api/programas/listall", authConfig());
      return response.data.programas || [];
    } catch (error) {
      console.error("Error al obtener la lista de programas:", error);
      return [];
    }
  },

  obtenerCentros: async () => {
    try {
      const response = await axios.get(
        "/api/centrosdeformacion/listall",
        authConfig()
      );
      return response.data.centros || [];
    } catch (error) {
      console.error("Error al obtener la lista de centros:", error);
      return [];
    }
  },

  obtenerGrupos: async () => {
    try {
      const response = await axios.get("/api/grupos/listall", authConfig());
      console.log("Lista de grupos:", response.data);
      return response.data.grupos || [];
    } catch (error) {
      console.error("Error al obtener la lista de grupos:", error.response?.data || error);
      return [];
    }
  },

  obtenerProgramasPorCentro: async (centroId) => {
    try {
      const response = await axios.get(
        `/api/programas/centro/${centroId}`,
        authConfig()
      );
      return response.data.programas || [];
    } catch (error) {
      console.error("Error al obtener los programas por centro:", error);
      return [];
    }
  },
};

export default senaFunciones;